// extracted by mini-css-extract-plugin
module.exports = {"price":"da","currency":"db","strikethrough":"dc","secondary":"dd"};